import { render } from "./GridMenu.vue?vue&type=template&id=b72e04a8&scoped=true"
import script from "./GridMenu.vue?vue&type=script&lang=js"
export * from "./GridMenu.vue?vue&type=script&lang=js"

import "./GridMenu.vue?vue&type=style&index=0&id=b72e04a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72e04a8"]])

export default __exports__